export default __webpack_public_path__ + "static/media/7_1.b1473b91.jpg";